import {ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, NgZone, OnChanges, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {PolicyService} from '../../../../../policy/services/policy.service';
import {DatePipe} from '@angular/common';
import {Router} from '@angular/router';
import {CalcPremDiffCollation, Collation, Policy, PolicyBenefitsAdded} from '../../../../models/policy.model';
import {GlobalQuestionService} from '../../../../services/global-question.service';
import {EntryType} from '../../../../constants';
import { UserStore } from 'src/app/modules/authentication/state/user.store';
import { Alert } from 'src/app/modules/shared/utilities';
import { newGuid } from 'src/app/modules/shared/questions/question-helper';
import { StorageService } from '../../../../services/storage.service';

declare var $: any;
declare var accounting: any;
declare function initModalHandler(): any;

enum Entity {
  Policy = 'Policy',
  Item = 'Item',
  Vap = 'Vap'
}

enum CancelDateSelection {
  Today = 'Today',
  Tomorrow = 'Tomorrow',
  EndOfMonth = 'EndOfMonth',
  SpecifiedDate = 'SpecifiedDate'
}

@Component({
    selector: 'app-cancel-policy',
    templateUrl: './cancel-policy.component.html',
    styleUrls: ['./cancel-policy.component.scss'],
    standalone: false
})
export class CancelPolicyComponent implements OnInit, OnChanges {

  @Input() policy: Policy;
  @Input() item: Collation;
  @Input() vap: PolicyBenefitsAdded;
  @Input() entity = '';
  @Input() source = '';
  @Input() new_session_id: any;
  @Input() frequency_id = 3;
  @Input() isEditPolicyPage = false;
  @Input() navigateOnCancel = true;
  @Output() getNewDataEdit = new EventEmitter<boolean>();
  //@Output() getNewData = new EventEmitter<boolean>();
  @Output() getNewData = new EventEmitter<boolean | [boolean, any?]>();
  @Output() pauseModal = new EventEmitter<boolean>();
@ViewChild('cancel-policy-summary-modal') cancelModal!: ElementRef;

  cancelDateSelection = '';
  cancelDate = '';
  responsetext = '';
  cancelDateValue: Date;
  refund: CalcPremDiffCollation;
  accounting: any;
  spinner = false;
  entities = Entity;
  user: any;
  cancelDateSelectionEnum = CancelDateSelection;
  cancelSelectionDateModalButtonEnabled = false;
  reasonProvided = false;
  startMinDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() + 1);
  options: any = [];
  reason = {id: 0, text: ""};
  uniqueId = newGuid();
  alertModalId = `cancel-policy-alert-modal-${this.uniqueId}`;
  dateModalId = `cancel-policy-date-modal-${this.uniqueId}`;
  summaryModalId = `cancel-policy-summary-modal-${this.uniqueId}`;
  constructor(
    private policyService: PolicyService,
    private questionService: GlobalQuestionService,
    private userStore: UserStore,
    public datePipe: DatePipe,
    private ngZone: NgZone,
    public router: Router,
    private storageService: StorageService) {
      this.user = this.userStore.getValue();
  }

  ngOnInit(): void {
    
    accounting.settings = {
      currency: {
        symbol: 'R ', // default currency symbol is '$'
        format: '%s%v', // controls output: %s = symbol, %v = value/number (can be object: see below)
        decimal: '.', // decimal point separator
        thousand: ' ', // thousands separator
        precision: 0, // decimal places
      },
      number: {
        precision: 0, // default precision on numbers is 0
        thousand: ' ',
        decimal: '.',
      }
    };
    this.accounting = accounting;
    const parameters = new Map<string, string>();
    //parameters.set('new_session_id', this.session_details.session_id);
    this.questionService.runCommandNew('[dbo].[getCancellationReasons]', parameters).subscribe((reasons) => {
      
      if (this.user?.broker_id > 0 || this.user.console_access){
        reasons.forEach(r => {
            this.options.push({value:r?.cancellation_reason_id, label: r?.cancellation_reason})
        });
      }
      else{
        reasons.forEach(r => {
          if (r?.show_client === 1){
            this.options.push({value:r?.cancellation_reason_id, label: r?.cancellation_reason})
          }
        });
      }

    })
    initModalHandler();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.user.console_access || this.user.broker_id > 0) { // console access or broker can back date
      this.startMinDate = new Date(1900, 0, 0)
    }
    if (changes?.policy?.currentValue !== changes?.policy?.previousValue) {
      this.policy = changes?.policy?.currentValue;
      if (this.accounting) {
        this.accounting.settings.currency.symbol = `${this.policy?.currency ? this.policy?.currency : 'R'} `;
      }
    }
  }
  ngAfterViewInit() {
    $(`#${this.summaryModalId}`).on('hidden.bs.modal', () => {
      //Call a method on the component to emit the event
      try {
        this.isEditPolicyPage = this.storageService.getJson('isEditPolicyPage', 'flow');
      }
      catch { }
      if (this.isEditPolicyPage) {
        this.getNewDataEdit.emit(true);
        this.storageService.remove('isEditPolicyPage', 'flow')
      }

    });
  }
  showCancelModal(entity: Entity, item?: any): void {
    this.entity = entity;
    if (item) {
      if (entity === Entity.Item) {
        this.item = item;
      } else if (entity === Entity.Vap) {
        this.vap = item;
      }
    }
    
    // Lets store this in sessionStorage in case Jquery destroys it;
    if (this.entity != '') this.storageService.setJson('entity', this.entity, 'flow');
    if (this.vap) this.storageService.setJson('vap', this.vap, 'flow');
    if (this.item) this.storageService.setJson('cancel-policy-item', this.item, 'flow');
    if (this.isEditPolicyPage) this.storageService.setJson('isEditPolicyPage', this.isEditPolicyPage, 'flow');
    $(`#${this.dateModalId}`).modal('show');
  }

  onDatePickerChange(value: any): void {
    this.cancelDate = value;
    this.cancelDateValue = new Date(this.cancelDate);

    this.cancelSelectionDateModalButtonEnabled = !!this.cancelDate;
  }

  onDateSelectionChange(): void {
    if (this.cancelDateSelection === CancelDateSelection.Today) {
      const today = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());
      this.cancelDate = this.datePipe.transform(today, 'yyyy-MM-dd');
    } else if (this.cancelDateSelection === CancelDateSelection.EndOfMonth) {
      const today = new Date();
      this.cancelDate = this.datePipe.transform(new Date(today.getFullYear(), today.getMonth() + 1, 0), 'yyyy-MM-dd');
    }

    if (this.cancelDate) {
      this.cancelSelectionDateModalButtonEnabled = true;
      this.cancelDateValue = new Date(this.cancelDate);
    } else {
      this.cancelSelectionDateModalButtonEnabled = false;
    }
  }

  populateProperties(): void {
    this.questionService.spinner(true);
    const parameters = new Map<string, string>();
    switch (this.entity) {
      case Entity.Policy:
        parameters.set('session_id', this.policy.session_id.toString());
        parameters.set('status_id', '4');
        parameters.set('class_id', '0');
        parameters.set('item_id', '0');
        parameters.set('begin_date', this.cancelDate);
        parameters.set('end_date', this.cancelDate);
        parameters.set('user_updated', this.user?.person_id.toString());
        this.questionService.runCommandNew('savePolicyUpdate', parameters)
          .subscribe(response => {
            try{
              this.refund = response.find(item => item.entry_type === EntryType.premium && item.frequency_id === this.frequency_id);
              this.refund.description = this.refund?.description_json ? JSON.parse(this.refund?.description_json) : [];
              $(`#${this.dateModalId}`).modal('hide');
              $(`#${this.dateModalId}`).on('hidden.bs.modal', () => {
                $(`#${this.summaryModalId}`).modal('show');
              });
            }
            catch{
              Alert("Technical Error experienced");
            }
            
            this.questionService.spinner(false);
          }, err => {
            this.questionService.spinner(false);
            Alert("Technical Error experienced");
          });
        break;
      case Entity.Item:
       // const parameters = new Map<string, string>();
        parameters.set('session_id', this.policy.session_id.toString());
        parameters.set('status_id', '4');
        parameters.set('class_id', this.item?.class_id.toString());
        parameters.set('item_id', this.item?.session_item_id.toString());
        parameters.set('begin_date', this.cancelDate);
        parameters.set('end_date', this.cancelDate);
        parameters.set('user_updated', this.user?.person_id.toString());
        this.questionService.runCommandNew('savePolicyUpdate', parameters)
          .subscribe(response => {
            this.refund = response.find(item => item.entry_type === EntryType.premium && item.frequency_id === this.frequency_id);
            this.refund.description = this.refund?.description_json ? JSON.parse(this.refund?.description_json) : [];
            $(`#${this.dateModalId}`).modal('hide');
            $(`#${this.dateModalId}`).on('hidden.bs.modal', () => {
              $(`#${this.summaryModalId}`).modal('show');
            });
            this.questionService.spinner(false);
          }, err => {
            this.questionService.spinner(false);
            Alert("Technical Error experienced");
          });
        break;
      case Entity.Vap:
        let vap_id = this.vap?.vaps_id ? this.vap?.vaps_id : this.vap?.product_vaps_id ? this.vap?.product_vaps_id : 0;
        parameters.set('session_id', this.policy.session_id.toString());
        parameters.set('status_id', '4');
        parameters.set('class_id', this.vap?.class_id.toString());
        parameters.set('item_id', this.vap?.session_item_id.toString());
        parameters.set('begin_date', this.cancelDate);
        parameters.set('end_date', this.cancelDate);
        parameters.set('vaps_id', vap_id.toString());
        parameters.set('user_updated', this.user?.person_id.toString());
        this.questionService.runCommandNew('savePolicyUpdate', parameters)
          .subscribe(response => {
            this.refund = response.find(item => item.entry_type === EntryType.premium && item.frequency_id === this.frequency_id);
            this.refund.description = this.refund?.description_json ? JSON.parse(this.refund?.description_json) : [];
            $(`#${this.dateModalId}`).modal('hide');
            $(`#${this.dateModalId}`).on('hidden.bs.modal', () => {
              $(`#${this.summaryModalId}`).modal('show');
            });
            this.questionService.spinner(false);
          }, err => {
            this.questionService.spinner(false);
            Alert("Technical Error experienced");
          });
        break;
    }
    
  }

  changeToCancelled(): void {
    this.questionService.spinner(true);
    if (this.entity === Entity.Item || this.entity === Entity.Vap) {
       try {
        this.isEditPolicyPage = this.storageService.getJson('isEditPolicyPage', 'flow');
      }
      catch { }
      console.log(this.isEditPolicyPage);
      if (this.isEditPolicyPage) {
          $(`#${this.summaryModalId}`).modal('hide'); 
           this.questionService.spinner(false);
            this.getNewData.emit(true);
      } else {
        const parameters = new Map<string, string>();
        parameters.set('session_id', this.policy.session_id.toString());
        parameters.set('status_id', '1');
        parameters.set('class_id', '0');
        parameters.set('item_id', '0');
        parameters.set('begin_date', this.cancelDate);
        parameters.set('end_date', this.cancelDate);
        parameters.set('user_updated', this.user?.person_id.toString());
        this.questionService.runCommandNew('savePolicyUpdate', parameters)
          .subscribe(result => {
            this.policyService.submitPolicyUpdates(this.policy?.session_id)
              .subscribe((response) => {
                $(`#${this.summaryModalId}`).modal('hide');
                $(`#${this.dateModalId}`).modal('hide');
                this.getNewData.emit([true,response]);
                this.questionService.spinner(false);
                if (response[0].log_id) {
                  Alert("Technical Error experienced");
                }
                if (response[0].status) {
                  Alert(response[0]?.status);
                }
              }, err => {
                this.questionService.spinner(false);
                Alert("Technical Error experienced");
              });
          }, err => {
            this.questionService.spinner(false);
            Alert("Technical Error experienced");
          });

      }
    } else if (this.entity === Entity.Policy) {
      this.policyService.submitPolicyUpdates(this.policy?.session_id)
        .subscribe(( response ) => {
          $(`#${this.summaryModalId}`).modal('hide');
          $(`#${this.dateModalId}`).modal('hide');
          this.questionService.spinner(false);
          if (response[0].log_id) {
            Alert("Technical Error experienced");
          }
          try {
            this.isEditPolicyPage = this.storageService.getJson('isEditPolicyPage', 'flow');
          }
          catch { }
          if (this.isEditPolicyPage) {
            this.storageService.remove('isEditPolicyPage', 'flow');
            this.getNewDataEdit.emit(true);
            return;
          }
          this.getNewData.emit(true);
          if (response[0].status) {
            Alert(response[0]?.status);
          }
          if (this.navigateOnCancel) {
            let url = this.storageService.get('previous-document-page', 'flow');
            this.router.navigate([url]);
          }
        }, err => {
          this.questionService.spinner(false);
          Alert("Technical Error experienced");
        });
    }
  }

  removeAction(status_id: number): void {
    this.questionService.spinner(true);
    if (this.entity === Entity.Policy) {
      this.policyService.removePolicyUpdate(this.policy?.session_id, 0, '0', 0, status_id)
        .subscribe(() => {
          const today = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
          this.policyService.calcPremDiff(this.policy?.session_id, today)
            .subscribe(() => {
              this.policyService.submitPolicyUpdates(this.policy?.session_id)
                .subscribe(() => {
                  this.getNewData.emit(true);
                  this.questionService.spinner(false);
                }, err => {
                  this.questionService.spinner(false);
                });
            }, err => {
              this.questionService.spinner(false);
            });
        }, err => {
          this.questionService.spinner(false);
        });
    } else if (this.entity === Entity.Item) {
      this.policyService.removePolicyUpdate(this.policy?.session_id, this.item?.class_id, this.item?.session_item_id, 0, status_id)
        .subscribe(() => {
          let today: any;
          today = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
          this.policyService.calcPremDiff(this.policy?.session_id, today)
            .subscribe(() => {
              this.policyService.submitPolicyUpdates(this.policy?.session_id)
                .subscribe(() => {
                  this.getNewData.emit(true);
                  this.questionService.spinner(false);
                }, err => {
                  this.questionService.spinner(false);
                });
            }, err => {
              this.questionService.spinner(false);
            });
        }, err => {
          this.questionService.spinner(false);
        });
    } else if (this.entity === Entity.Vap) {
      this.policyService.removePolicyUpdate(this.policy?.session_id, this.vap?.class_id, this.vap?.session_item_id, 0, status_id, this.vap?.vaps_id)
        .subscribe(() => {
          const today = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
          this.policyService.calcPremDiff(this.policy?.session_id, today)
            .subscribe(() => {
              this.policyService.submitPolicyUpdates(this.policy?.session_id)
                .subscribe(() => {
                  this.getNewData.emit(true);
                  this.questionService.spinner(false);
                }, err => {
                  this.questionService.spinner(false);
                });
            }, err => {
              this.questionService.spinner(false);
            });
        }, err => {
          this.questionService.spinner(false);
        });
    }
    $(`#${this.dateModalId}`).modal('hide');
    
  }

  closeCancelPolicyAlertModal(): void {
    $(`#${this.alertModalId}`).modal('hide');
  }

  closeCancelPolicyDateModal(): void {
    $(`#${this.dateModalId}`).modal('hide');
  }

  closeCancelPolicySummaryModal(): void {
    $(`#${this.summaryModalId}`).modal('hide');
  }
  getReasonID(event: any): void{
    this.reason.id = +event;
    
    if (this.reason?.id > 0 && this.reason?.text !== ""){
      this.reasonProvided = true;
    }
    else{
      this.reasonProvided = false;
    }
  }
  getReasonText(): void{
    
    this.reason.text = this.responsetext;
    if (this.reason?.id > 0 && this.reason?.text !== ""){
      this.reasonProvided = true;
    }
    else{
      this.reasonProvided = false;
    }
  }
  saveCancellationRequest(): void {
    
    if (this.entity == '' || !this.vap || !this.item) { //We have a problems, lets fetch from sessionStorage
      try {
        this.entity = this.storageService.getJson('entity', 'flow');
        this.vap = this.storageService.getJson('vap', 'flow');
        this.item = this.storageService.getJson('cancel-policy-item', 'flow');
      }
      catch { }
    }
    //Clean up
    this.storageService.remove('entity', 'flow');
    this.storageService.remove('vap', 'flow');
    this.storageService.remove('cancel-policy-item', 'flow');
    if (this.user?.console_access || this.user?.broker_id > 0) {
      const parameters = new Map<string, string>();
      parameters.set('policy_id', this.policy.policy_id.toString());
      parameters.set('date_cancellation', this.cancelDate?.toString());
      parameters.set('cancellation_reason_id', this.reason?.id.toString());
      parameters.set('send_email', '0');
      parameters.set('user_id', this.user?.person_id.toString());
      parameters.set('description', this.reason?.text);
      this.questionService.runCommandNew('[dbo].[saveCancellationRequest]', parameters).subscribe((response) => {
        this.populateProperties();
      })
    }
    else if (this.entity == Entity.Item || this.entity == Entity.Vap) {
      const parameters = new Map<string, string>();
      parameters.set('policy_id', this.policy.policy_id.toString());
      parameters.set('date_cancellation', this.cancelDate?.toString());
      parameters.set('cancellation_reason_id', this.reason?.id.toString());
      parameters.set('send_email', '0');
      parameters.set('user_id', this.user?.person_id.toString());
      parameters.set('description', this.reason?.text);
      this.questionService.runCommandNew('[dbo].[saveCancellationRequest]', parameters).subscribe((response) => {
        this.populateProperties();
      })

    }
    else {
      const parameters = new Map<string, string>();
      parameters.set('policy_id', this.policy.policy_id.toString());
      parameters.set('date_cancellation', this.cancelDate?.toString());
      parameters.set('cancellation_reason_id', this.reason?.id.toString());
      parameters.set('description', this.reason?.text);
      parameters.set('user_id', this.user?.person_id.toString());
      this.questionService.runCommandNew('[dbo].[saveCancellationRequest]', parameters).subscribe((response) => {
        Alert(response[0]?.response);
        $(`#${this.dateModalId}`).modal('hide');

      })
    }
  }
  parseJSON(obj: string): any {
    try {
      return JSON.parse(obj)[0];
    } catch (e) {
      return JSON.parse(obj);
    }
  }

}
